import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css'; //phone or email icon
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import "./App.css";


// 🔹 Main Pages
import ScrollToTop from "./Pages/ScrollToTop";
import Home from "./Pages/Home";
import AboutUs from "./Pages/Aboutus";
import Career from "./Pages/Career";
import Certificate from "./Pages/certificate";
import ControlTechniques from "./Pages/ControlTechniques";
import FAQs from "./Pages/FAQs";
import Local from "./Pages/Local";
import Contact from "./Pages/Contact";
import Videocentre from "./Pages/Videocentre";
import Solution from "./Pages/Solution";

// 🔹 Product Categories
import Product from "./Pages/Product";
// import Controlsystem from "./Pages/Controlsystem";
// import Transmitter from "./Pages/Transmitter";
// import Receiver from "./Pages/Receiver"; 


import ProductDetails from "./Pages/ProductDetails";
import ProductView from "./Pages/ProductView";

import SolutionList from "./Pages/SolutionList";
import SolutionDetails from "./Pages/SolutionDetails";
import ProductCategory from "./Pages/ProductCategory";
import ProductSubcategory from "./Pages/ProductSubcategory";

function App() { 
  return (
    <Router>
      <Header />
       <ScrollToTop />
      <Routes>
        {/* 🔹 Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/career" element={<Career />} />
        <Route path="/certificate" element={<Certificate />} />
        <Route path="/controltechniques" element={<ControlTechniques />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/local" element={<Local />} />
        <Route path="/videocentre" element={<Videocentre />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/solution" element={<Solution />} />
        <Route path="/solution/:category" element={<SolutionList />} />
        <Route path="/solution/:category/:id" element={<SolutionDetails />} />

        {/* 🔹 Product Categories */}
        <Route path="/product" element={<Product />} />
        <Route path="/product/:category" element={<ProductCategory />} />
        <Route path="/product/:category/:type" element={<ProductSubcategory />} />
        <Route path="/product/:category/:type/:model" element={<ProductView />} />
        <Route path="/product/:category/:type/:model/:id" element={<ProductDetails />} />
        {/* <Route path="/product/:category/:type/:variant" element={<ProductDetails />} /> */}


        {/* <Route path="/product/controlsystem" element={<Controlsystem />} /> */}
        {/* <Route path="/product/controlsystem/transmitter/:model" element={<Transmitter />} /> */}
        {/* <Route path="/product/controlsystem/receiver" element={<Receiver />} /> */}






      </Routes>



        <div className="side-contact-buttons">
          <a href="tel:+91 7942963398" className="side-contact">
            <span className="icon"><i className="fa-solid fa-phone" ></i></span>
            <span className="text">. &nbsp; &nbsp; &nbsp; &nbsp; +91 7942963398</span>
          </a>

          <a href="mailto:sales.2@skylifestyle.in" className="side-contact">
            <span className="icon"><i className="fa-solid fa-envelope"></i></span>
            <span className="text">.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; sales.2@skylifestyle.in</span>
          </a>
        </div>


      <Footer />
    </Router>
  );
}
 
export default App;